const ITEMS = [
  "Strategic Sourcing",
  "In-Situ Factory Audit",
  "Pre-Shipment Inspection",
  "Nearshoring Feasibility",
  "Logistics Audit",
  "NCNDA Protection",
];

export default function Marquee() {
  return (
    <section
      aria-label="Capabilities"
      className="bg-[#0B1630] border-y border-[#C5B358]/20 py-5 overflow-hidden"
      data-testid="capabilities-marquee"
    >
      <div className="marquee-track flex w-max items-center gap-12 whitespace-nowrap">
        {[0, 1].map((copy) => (
          <div key={copy} aria-hidden={copy === 1} className="flex items-center gap-12">
            {ITEMS.map((t) => (
              <span key={`${copy}-${t}`} className="flex items-center gap-12">
                <span className="eyebrow text-[#A3B1C6]">{t}</span>
                <span className="w-1.5 h-1.5 rotate-45 bg-[#C5B358] inline-block flex-shrink-0" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </section>
  );
}